<div class="overlay" *ngIf="isLoading | async">
  <div class="spinner">
    <div class="spinner-part spinner-part1"></div>
    <div class="spinner-part spinner-part2"></div>
    <img src="/assets/images/motorbike.png" alt="Suzuki Bike" class="spinner-center">
  </div>
</div>

<div class="container-fluid pl-0 h-100">
  <div class="container-inner">
    <div *ngIf="!isCreate && !isEdit">
      <div class="header-container">
        <h2>VN Mapping list</h2>
        <div class="actions">
          <div class="search-container">
            <select class="form-select" [formControl]="filterInput" >
              <option value disabled selected>--Select filter type--</option>
              <option value="0">Virtual Number</option>
              <option value="1">Outlet</option>
            </select>
          </div>
          <div class="search-container">
            <input *ngIf="filterInput.value == '0'" type="text" [formControl]="searchInput" placeholder="Search..."
              (input)="applyFilter()" (keypress)="allowNumbersOnly($event)" [disabled]="!filterInput.value"
              class="form-control" />
            <input *ngIf="filterInput.value == '1'" type="text" [formControl]="searchInput" placeholder="Search..."
              (input)="applyFilter()" [disabled]="!filterInput.value" class="form-control" />
            <span class="clear-icon" *ngIf="searchInput.value" (click)="clearSearch()">&times;</span>
          </div>
          <div class="button-container">
            <button mat-raised-button class="add-button mr-1" (click)="goToImport()"> Import</button>
            <button mat-raised-button class="add-button" (click)="isCreate = true;create()"> Add VN-Mapping</button>
          </div>
        </div>
      </div>

      <div class="leads-table mb-3">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
          <ng-container matColumnDef="SNo">
            <th mat-header-cell *matHeaderCellDef> S.No </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ (paginatorRef.pageIndex *
              paginatorRef.pageSize) + (i + 1) }}</td>
          </ng-container>
          <ng-container matColumnDef="forwarding_number">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Forwarding
              Number</th>
            <td mat-cell *matCellDef="let element">{{element.forwarding_number}}</td>
          </ng-container>
          <ng-container matColumnDef="outlet_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Outlet</th>
            <td mat-cell *matCellDef="let element">
              {{ element?.outlet?.outlet_name }} ({{ element?.outlet?.outlet_code || '' }})
            </td>
          </ng-container>
          <ng-container matColumnDef="lead_source_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead
              Source</th>
            <td mat-cell *matCellDef="let element">{{element?.lead_source?.lead_source || '-'}}</td>
          </ng-container>
          <ng-container matColumnDef="lead_sub_source_id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Lead
              Sub Source </th>
            <td mat-cell *matCellDef="let element">{{element?.lead_sub_source?.lead_sub_source || '-'}}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
            <td mat-cell *matCellDef="let element"
              [ngClass]="element.status == 1 ? 'status_active' : 'status_inactive'">
              {{element.status ? 'Active' : 'In-Active'}}</td>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>CreatedAt</th>
            <td mat-cell *matCellDef="let element">{{element.createdAt | date:
              'yyyy-MM-dd'}}</td>
          </ng-container>
          <ng-container matColumnDef="updatedAt">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>UpdatedAt</th>
            <td mat-cell *matCellDef="let element">{{element.updatedAt | date:
              'yyyy-MM-dd'}}</td>
          </ng-container>
          <ng-container matColumnDef="virtual_number">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Vitual
              Number</th>
            <td mat-cell *matCellDef="let element">{{element.virtual_number}}</td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Action</th>
            <td mat-cell *matCellDef="let element" style="text-align: center;">
              <img [src]="bucketurl + '/images/pen.png'" class="edit-pen" title="Edit" (click)="edit(element)">
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" style="text-align: center; padding: 20px 0;" colspan="7">No data found!</td>
          </tr>
        </table>
        <mat-paginator #paginatorRef (page)="pageHandler($event)" [pageSizeOptions]="[10, 50]"
          showFirstLastButtons></mat-paginator>
      </div>
    </div>

    <div *ngIf="isCreate || isEdit">
      <div class="header-container">
        <h2>{{ isEdit ? 'Edit' : 'Add' }} VN-Mapping</h2>
        <div class="button-container">
          <button mat-raised-button class="add-button" (click)="back()">Back to
            List</button>
        </div>
      </div>
      <form [formGroup]="virtualNumberForm">
        <div class="row" *ngIf="!isEdit">
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>VN Type</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" [(ngModel)]="vnType"  [ngModelOptions]="{standalone: true}" (change)="onTypeChange()">
                <option value="" disabled selected>Select Type</option>
                <option value="1">Old FLow</option>
                <option value="2">New FLow (IVR)</option>
              </select>
            </div>
          </div>
        </div>
         <div class="row" *ngIf="vnType == '1'">
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4" *ngIf="!isEdit">
            <div class="themeinput">
              <label>Virtual Number</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="virtual_number"
                [ngClass]="{ 'is-invalid': submitted && f['virtual_number'].errors }">
                <option value="" disabled selected>Select Virtual Number</option>
                <option *ngFor="let virtual of dropdownData?.virtualNumber" [value]="virtual.virtual_number">
                  {{virtual.virtual_number}}</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['virtual_number'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['virtual_number'].errors['required']">Virtual
                  number is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Forwarding Number</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <input type="text" class="form-control" formControlName="forwarding_number" (keypress)="keyPress($event)"
                pattern="[0-9]*" maxLength="10"
                [ngClass]="{ 'is-invalid': submitted && f['forwarding_number'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['forwarding_number'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['forwarding_number'].errors['required']">Forwarding
                  Number is required</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-sm-12 col-md-4 mt-4" *ngIf="isEdit" style="pointer-events: none;">
            <div class="themeinput">
              <label>Virtual Number</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <input type="text" class="form-control" readonly formControlName="virtual_number"
                [ngClass]="{ 'is-invalid': submitted && f['virtual_number'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['virtual_number'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['virtual_number'].errors['required']">Virtual
                  number is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Outlet</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="outlet_id"
                [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }">
                <option value="" disabled selected>Select Outlet</option>
                <option *ngFor="let outlet of outletList" [value]="outlet.id">{{outlet.outlet_name}} (
                  {{outlet.outlet_code}} - {{outlet.location_code}})</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['outlet_id'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['outlet_id'].errors['required']">Outlet
                  is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Base Lead Source</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="base_lead_source"
                [ngClass]="{ 'is-invalid': submitted && f['base_lead_source'].errors }">
                <option value="" disabled selected>Select Base Lead Source</option>
                <option *ngFor="let source of dropdownData.base_lead_source" [value]="source.id">
                  {{source.base_lead_source}}</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['base_lead_source'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['base_lead_source'].errors['required']">
                  Base Lead Source is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Lead Source</label>
              <select class="form-select" formControlName="lead_source"
                [ngClass]="{ 'is-invalid': submitted && f['lead_source'].errors }">
                <option value="" disabled selected>Select Lead Source</option>
                <option *ngFor="let source of dropdownData.lead_source" [value]="source.id">{{source.lead_source}}
                </option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['lead_source'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['lead_source'].errors['required']">Lead
                  Source is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Lead Sub Source</label>
              <select class="form-select" formControlName="lead_sub_source"
                [ngClass]="{ 'is-invalid': submitted && f['lead_sub_source'].errors }">
                <option value="" disabled selected>Select Lead Source</option>
                <option *ngFor="let subSource of dropdownData.lead_sub_source" [value]="subSource.id">
                  {{subSource.lead_sub_source}}</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['lead_sub_source'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['lead_sub_source'].errors['required']">Lead
                  Source is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Status</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="status"
                [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                <option value disabled selected>Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['status'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['status'].errors['required']">Status
                  is required</div>
              </div>
            </div>
          </div>

        </div>
        <div class="row" *ngIf="vnType == '2'">
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4" *ngIf="!isEdit">
            <div class="themeinput">
              <label>Virtual Number</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="virtual_number"
                [ngClass]="{ 'is-invalid': submitted && f['virtual_number'].errors }">
                <option value="" disabled selected>Select Virtual Number</option>
                <option *ngFor="let virtual of dropdownData?.virtualNumber" [value]="virtual.virtual_number">
                  {{virtual.virtual_number}}</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['virtual_number'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['virtual_number'].errors['required']">Virtual
                  number is required</div>
              </div>
            </div>
          </div>
        
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (English Sales)</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <input type="text" class="form-control" formControlName="fn_english_sales" (keypress)="keyPress($event)"
                pattern="[0-9]*" maxLength="10" [ngClass]="{ 'is-invalid': submitted && f['fn_english_sales'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_english_sales'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_english_sales'].errors['required']">FN
                  (English Sales) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (English Non-Sales)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_english_non_sales"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_english_non_sales'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_english_non_sales'].errors"
                class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_english_non_sales'].errors['required']">FN
                  (English Non-Sales) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (English Others)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_english_others"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_english_others'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_english_others'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_english_others'].errors['required']">FN
                  (English Others) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (Hindi Sales)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_hindi_sales"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_hindi_sales'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_hindi_sales'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_hindi_sales'].errors['required']">FN (Hindi
                  Sales) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (Hindi Non-Sales)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_hindi_non_sales"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_hindi_non_sales'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_hindi_non_sales'].errors"
                class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_hindi_non_sales'].errors['required']">FN
                  (Hindi
                  Non-Sales) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (Hindi Others)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_hindi_others"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_hindi_others'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_hindi_others'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_hindi_others'].errors['required']">FN (Hindi
                  Others) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (Regional Sales)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_regional_sales"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_regional_sales'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_regional_sales'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_regional_sales'].errors['required']">FN
                  (Regional Sales) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (Regional Non-Sales)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_regional_non_sales"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_regional_non_sales'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_regional_non_sales'].errors"
                class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_regional_non_sales'].errors['required']">FN
                  (Regional Non-Sales) is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>FN (Regional Others)</label>
              <input type="text" class="form-control" maxLength="10" formControlName="fn_regional_others"
                (keypress)="keyPress($event)" pattern="[0-9]*"
                [ngClass]="{ 'is-invalid': submitted && f['fn_regional_others'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['fn_regional_others'].errors"
                class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['fn_regional_others'].errors['required']">FN
                  (Regional Others) is required</div>
              </div>
            </div>
          </div>

          <div class="col-lg-3 col-sm-12 col-md-4 mt-4" *ngIf="isEdit" style="pointer-events: none;">
            <div class="themeinput">
              <label>Virtual Number</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <input type="text" class="form-control" readonly formControlName="virtual_number"
                [ngClass]="{ 'is-invalid': submitted && f['virtual_number'].errors }">
              <div *ngIf="submitted && virtualNumberForm.controls['virtual_number'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['virtual_number'].errors['required']">Virtual
                  number is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Outlet</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="outlet_id"
                [ngClass]="{ 'is-invalid': submitted && f['outlet_id'].errors }">
                <option value="" disabled selected>Select Outlet</option>
                <option *ngFor="let outlet of outletList" [value]="outlet.id">{{outlet.outlet_name}} (
                  {{outlet.outlet_code}}  - {{outlet.location_code}})</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['outlet_id'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['outlet_id'].errors['required']">Outlet
                  is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Base Lead Source</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="base_lead_source"
                [ngClass]="{ 'is-invalid': submitted && f['base_lead_source'].errors }">
                <option value="" disabled selected>Select Base Lead Source</option>
                <option *ngFor="let source of dropdownData.base_lead_source" [value]="source.id">
                  {{source.base_lead_source}}</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['base_lead_source'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['base_lead_source'].errors['required']">
                  Base Lead Source is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Lead Source</label>
              <select class="form-select" formControlName="lead_source"
                [ngClass]="{ 'is-invalid': submitted && f['lead_source'].errors }">
                <option value="" disabled selected>Select Lead Source</option>
                <option *ngFor="let source of dropdownData.lead_source" [value]="source.id">{{source.lead_source}}
                </option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['lead_source'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['lead_source'].errors['required']">Lead
                  Source is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Lead Sub Source</label>
              <select class="form-select" formControlName="lead_sub_source"
                [ngClass]="{ 'is-invalid': submitted && f['lead_sub_source'].errors }">
                <option value="" disabled selected>Select Lead Source</option>
                <option *ngFor="let subSource of dropdownData.lead_sub_source" [value]="subSource.id">
                  {{subSource.lead_sub_source}}</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['lead_sub_source'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['lead_sub_source'].errors['required']">Lead
                  Source is required</div>
              </div>
            </div>
          </div>
          <div class="col-lg-3 col-sm-12 col-md-4 mt-4">
            <div class="themeinput">
              <label>Status</label><span style="color: red; font-size: 15px;">&nbsp;*</span>
              <select class="form-select" formControlName="status"
                [ngClass]="{ 'is-invalid': submitted && f['status'].errors }">
                <option value disabled selected>Select Status</option>
                <option value="1">Active</option>
                <option value="0">Inactive</option>
              </select>
              <div *ngIf="submitted && virtualNumberForm.controls['status'].errors" class="invalid-feedback">
                <div *ngIf="virtualNumberForm.controls['status'].errors['required']">Status
                  is required</div>
              </div>
            </div>
          </div>

        </div>
        <div class="row justify-content-end">
          <div class="col-auto d-flex gap-3 mt-4">
            <button type="submit" mat-raised-button class="create-button" (click)="onSubmit()">
              {{ isEdit ? 'Update' : 'Create' }}
            </button>
            <button type="button" mat-raised-button class="clear-button" *ngIf="!isEdit" (click)="clearForm()">
              Clear
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>
</div>